import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cdaf29ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"inline-block","margin-right":"10px"} }
const _hoisted_2 = { class: "list" }
const _hoisted_3 = { class: "flex1 content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "待合并线索：", -1))
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "flex1 content" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "ID：", -1))
const _hoisted_8 = { class: "name" }

import { ref } from 'vue'
import { DcMessage } from '@dc-platform/dc-components'
import { clueMerge as zbuClueMerge } from '@/api/marketing/marketingManage'
import { clueMerge as lbuClueMerge } from '@/api/yuntuSales/clueManage'
import type { ClueManage } from '@/typings/api/marketingManage'
import type { PropType } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'clueMerge',
  props: {
  data: {
    type: Array as PropType<ClueManage[]>,
    default: () => {
      return []
    }
  },
  type: {
    type: String,
    default: 'customer' // customer 客户 clue 线索
  },
  title: {
    type: String
  },
  tips: {
    type: String // 描述
  },
  appId: {
    type: String, // 描述
    default: 'cos_zbu'
  }
},
  emits: ['success'],
  setup(__props, { emit: __emit }) {

const props = __props
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref()
const editForm = ref<any>({})
// 函数枚举对象
const clueMerge = {
  cos_zbu: zbuClueMerge,
  cos_lbu: lbuClueMerge
}
const emit = __emit

const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const { targetClueId } = editForm.value
    const originalIdList: any[] = []
    props.data.forEach((item) => {
      if (item.clueId !== targetClueId) {
        originalIdList.push(item.clueId)
      }
    })
    const p = {
      targetClueId,
      originalIdList
    }
    clueMerge[props.appId](p)
      .then(() => {
        visible.value = false
        emit('success')
        DcMessage.success('合并成功')
      })
      .finally(() => {
        loading.value = false
      })
  })
}
const showModal = () => {
  // 验证数量
  if (!props.data || props.data.length < 2) {
    DcMessage.error('请选择两条以上数据进行合并操作！')
    return
  }
  visible.value = true
  editForm.value = {}
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_CosModal = _resolveComponent("CosModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_button, { onClick: showModal }, {
      default: _withCtx(() => [
        _createTextVNode("合并")
      ]),
      _: 1
    }),
    _createVNode(_component_CosModal, {
      visible: visible.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
      title: "线索合并后数据将不能恢复，请谨慎操作！",
      class: "clueMerge",
      width: "750px",
      onOk: handleSubmit,
      confirmLoading: loading.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_alert, {
          message: "合并后，只保留选择的线索，删除其他的线索；原线索中不重复的联系人均会合并到新线索下。",
          type: "warning",
          "show-icon": ""
        }),
        _createElementVNode("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (item, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("p", {
                  class: "name",
                  title: item.customerName
                }, _toDisplayString(item.customerName), 9, _hoisted_5)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("p", _hoisted_8, _toDisplayString(item.clueId), 1)
              ])
            ]))
          }), 128))
        ]),
        (visible.value)
          ? (_openBlock(), _createBlock(_component_a_form, {
              key: 0,
              model: editForm.value,
              ref_key: "formRef",
              ref: formRef,
              autocomplete: "off"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, {
                  name: "targetClueId",
                  label: "合并到线索",
                  rules: [{ required: true, message: '请选择' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      value: editForm.value.targetClueId,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((editForm.value.targetClueId) = $event)),
                      placeholder: "请选择"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (item) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            key: item.clueId,
                            value: item.clueId
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.customerName), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "confirmLoading"])
  ]))
}
}

})